import { observer } from 'mobx-react-lite'
import { StyleSheet, View } from 'react-native'

import { getInitials } from '@ppwr/poker'

import { ChatKind } from '../../../../../models/api-store'
import { Chat as TChat } from '../../../../../models/communication/chat.store'
import Avatar from './partials/Avatar'
import ChatMessageContent from './partials/ChatMessageContent'

export interface ChatProps {
  chat: TChat
  firstItem: boolean
}

export const ChatMessage = observer(({ chat, firstItem }: ChatProps) => {
  const time = new Date(chat.timestamp ?? 0)
  const localDateTime = time.toLocaleString([], { hour12: true })
  const localTime = localDateTime.split(',')
  const showAvatar = !(chat.chatKind === ChatKind.dealer || chat.chatKind === ChatKind.engine)

  return (
    <View style={styles.container}>
      {showAvatar && (
        <View style={styles.avatar}>
          <Avatar color={chat.color ?? 'grey'} initials={getInitials(chat?.userName ?? '')} />
        </View>
      )}

      <ChatMessageContent
        message={chat?.message ?? ''}
        name={`${chat?.userName ?? ''}:`}
        type={chat.chatKind}
        timestamp={localTime[1]}
      />
    </View>
  )
})

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    marginVertical: 4,
    alignItems: 'center'
  },
  avatar: {
    justifyContent: 'flex-end',
    marginRight: 8,
    // paddingBottom: 8
    paddingTop: 4
  }
})
